const path = require('path');
const sprintf = require('i18next-sprintf-postprocessor');
const {availableLanguages} = require('./locales/d4c/metas.json');

module.exports = {
	i18n: {
		locales: availableLanguages,
		defaultLocale: 'en-us',
	},
	compatibilityJSON: 'v3',
	lowerCaseLng: true,
	localePath: path.resolve('./locales'),
	localeStructure: '{{ns}}/{{lng}}',
	nsSeparator: ':::',
	keySeparator: '::',
	postProcess: 'sprintf',
	use: [sprintf],
	ns: ['d4c', 'analytics'],
	defaultNS: 'd4c',
	serializeConfig: false,
	// Support translation reload in dev
	// https://github.com/i18next/next-i18next#reloading-resources-in-development
	reloadOnPrerender: process.env.NODE_ENV === 'development',
};
